export const announcementListRoute = {
  path: "/announcement",
  name: "announcement-list",
  component: () => import("../ui/announcement/announcement-list.vue")
};